<template>
  <div class="lol-page">
    <div class="title">
      <div class="logo"></div>
      <div class="name">联赛</div>
      <div class="time">时间</div>
      <div class="state">状态</div>
      <div class="team">队伍</div>
      <div class="score">比分</div>
      <div class="kill" v-if="type !== 'completed'">击杀</div>
      <div class="economy" v-if="type !== 'completed'">经济差</div>
      <div class="event">{{ type !== 'completed' ? '事件' : '' }}</div>
      <div class="video" v-if="type !== 'completed'">视/播</div>
      <div class="figure">指数</div>
      <div class="date">数据</div>
      <div class="play" v-if="type !== 'completed'">操作</div>
    </div>
    <div class="game-page-list" v-if="!pageLoading && filterGameList.length > 0">
      <!-- 置顶赛事 -->
      <div>
        <ul class="game-list">
          <KogGameItem class="game-list-item" v-for="(game, idx) in topGames" :key="`${game.tournament_id}-${idx}`"
            :game="game" />
        </ul>
      </div>
      <template v-if="playingGames.length > 0 && !['completed', 'schedule'].includes(type)">
        <div class="playing-list-title">
          <img src="../../assets/images/gaming/playing_game.png" alt="" />
          <span>进行中赛事</span>
        </div>
        <ul class="game-list">
          <KogGameItem class="game-list-item" v-for="(game, idx) in playingGames" :key="`${game.tournament_id}-${idx}`"
            :game="game" />
        </ul>
      </template>

      <template v-if="unStartGames.length > 0 && type != 'completed'">
        <div class="unstart-list-title" v-if="type != 'schedule'">
          <img src="../../assets/images/gaming/unstart_game.png" alt="" />
          <span>即将开始</span>
        </div>
        <ul class="game-list">
          <KogGameItem class="game-list-item" v-for="(game, idx) in unStartGames" :key="`${game.tournament_id}-${idx}`"
            :game="game" />
        </ul>
      </template>

      <template v-if="(endGames.length > 0 || pauseGames.length > 0) && type != 'schedule'">
        <div class="end-list-title" v-if="type != 'completed'">
          <img src="../../assets/images/gaming/end_game.png" alt=""><span>赛事已结束</span>
        </div>
        <ul class="game-list">
          <KogGameItem class="game-list-item" v-for="(game, idx) in endGames" :key="`${game.tournament_id}-${idx}`"
            :game="game" />
          <KogGameItem class="game-list-item" v-for="(game, idx) in pauseGames" :key="`${game.tournament_id}-${idx}`"
            :game="game" />
        </ul>
      </template>
    </div>
    <div class="page-loading" v-if="pageLoading">
      <div class="img-wrap">
        <img src="//static.fly2a.com/static/image/f-jiazai-min.png" />
      </div>
    </div>
    <div v-if="!pageLoading && isEmpty" class="empty-page">
      <img src="../../assets/images/gaming/empty-game.png" alt="">
      <p>暂无数据！</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import KogGameItem from "../../components/gaming/KogGameItem.vue";
import { websocketCommand } from '../../utils/websocket/index.js'
import { mapState } from 'vuex';
import dayjs from "dayjs";

export default {
  name: 'Kog',
  props: {
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      pageLoading: true,
      allList: [],
      wsObj: null
    }
  },
  components: {
    KogGameItem
  },
  computed: {
    ...mapState(['kogTopIds', 'kogCollectIds']),
    filterGameList() {
      let games = this.allList.filter(game => this.filters.includes(game.league_id)) || []
      if (this.type === 'collect') {
        games = games.filter(game => this.kogCollectIds.includes(game.tournament_id))
      }
      return games
    },
    topGames() {
      return this.filterGameList.filter(game => this.kogTopIds.includes(game.tournament_id)) || []
    },
    unStartGames() {
      return this.filterGameList.filter(game => {
        return game.state === 1 && !this.kogTopIds.includes(game.tournament_id)
      }) || []
    },
    playingGames() {
      return this.filterGameList.filter(game => {
        return game.state === 2 && !this.kogTopIds.includes(game.tournament_id)
      }) || []
    },
    endGames() {
      return this.filterGameList.filter(game => {
        return game.state === 3 && !this.kogTopIds.includes(game.tournament_id)
      }) || []
    },
    pauseGames() {
      return this.filterGameList.filter(game => {
        return game.state === 11 && !this.kogTopIds.includes(game.tournament_id)
      }) || []
    },
    type() {
      return this.$route.name
    },
    isEmpty() {
      const routerName = this.$route.name
      let isEmpty = this.filterGameList.length > 0 ? false : true
      if (routerName === 'gaming') {
        isEmpty = this.filterGameList.length > 0 ? false : true
      } else if (routerName === 'completed') {
        const endGameLength = this.endGames.length + this.pauseGames.length
        isEmpty = endGameLength > 0 ? false : true
      } else if (routerName === 'schedule') {
        isEmpty = this.unStartGames.length > 0 ? false : true
      }
      return isEmpty
    }
  },
  watch: {
    $route(to, from) {
      if (to.params.type !== from.params.type || to.query.day !== from.query.day || (to.name !== from.name && to.name !== 'collect')) {
        this.getList()
      }
    },
  },
  methods: {
    getList() {
      // 完赛和赛程添加请求参数
      let query = ''
      if (['completed', 'schedule'].includes(this.$route.name)) {
        if (this.$route.name === 'completed') {
          query = `?type=2`
        }
        let day = this.$route.query && this.$route.query.day || dayjs(new Date()).format('YYYYMMDD')
        if (day) {
          if (query) {
            query = `${query}&day=${day}`
          } else {
            query = `?day=${day}`
          }
        }
      }
      axios.get(COMMOND.NEW_BASE_URL + 'v2/kog_matches_list' + query).then(res => {
        this.pageLoading = false
        if (res.data.code === 200) {
          this.allList = res.data.data
        }
      })
    },
    // 建立连接、发起ws请求，以心跳方式，向服务端发送数据
    createWs() {
      this.wsObj = new WebSocket(this.wsUrl);
      // 若为对象类型，以回调方式发送
      websocketCommand(this.wsObj, 'create', JSON.stringify({ 'type': 'init', 'task_id': 'esport_kog' }), this.receiveMsg);
    },
    receiveMsg(msg) {
      // 赛事状态
      if (msg.type === 'WsKogStateList' || msg.type === 'WsKogScoreList') {
        const oList = JSON.parse(JSON.stringify(this.allList))
        const nList = oList.map(item => {
          const game = msg.result.filter(wsGame => wsGame.tournament_id === item.tournament_id)[0] || {}
          const newGame = Object.assign({}, item, game)
          return newGame
        })
        this.allList = nList
      }
      // 赛事列表
      if (msg.type === 'WsKogList') {
        const oList = JSON.parse(JSON.stringify(this.allList))
        const nList = oList.map(item => {
          const game = msg.result.filter(wsGame => wsGame.tournament_id === item.tournament_id)[0] || null
          if (game) {
            const info = item.info || {}
            info.home = Object.assign({}, info.home || {}, game.team.home || {})
            info.away = Object.assign({}, info.away || {}, game.team.away || {})
            delete game.team
            const newGameInfo = Object.assign({}, info, game)
            item.info = newGameInfo
          }
          return Object.assign({}, item, game)
        })
        this.allList = nList
      }
      // 指数推送
      if (msg.type === 'WsKogOddsList') {
        const oList = JSON.parse(JSON.stringify(this.allList))
        const nList = oList.map(item => {
          const game = msg.result.filter(wsGame => wsGame.tournament_id === item.tournament_id && wsGame.type === 101)[0] || null
          if (game) {
            item.home_odds_score = game.score
            item.away_odds_score = game.small_score
          }
          return item
        })
        this.allList = nList
      }
    }
  },
  mounted() {
    this.getList()
    this.createWs()
  },
  beforeDestroy() {
    websocketCommand(this.wsObj, 'close');
    this.wsObj = null;
  }
}
</script>

<style lang="less" scoped>
.lol-page {
  margin-top: 15px;

  .title {
    display: flex;
    height: 40px;
    line-height: 40px;
    background: #fff;
    color: #C0A3A6;
    font-size: 14px;

    div {
      text-align: center;
    }
  }

  .logo {
    width: 45px;
    margin-right: 35px;
  }

  .name {
    width: 105px;
    text-align: left !important;
  }

  .time {
    width: 80px;
  }

  .state {
    width: 90px;
  }

  .team {
    width: 108px;
  }

  .score {
    width: 92px;
  }

  .kill {
    width: 41px;
    margin-right: 20px;
  }

  .economy {
    width: 61px;
    margin-right: 10px;
  }

  .event {
    flex: 1;
    width: 206px;
  }

  .video {
    width: 63px;
    margin-right: 14px;
  }

  .figure {
    width: 63px;
    margin-right: 10px;
  }

  .date {
    width: 63px;
    margin-right: 22px;
  }

  .play {
    width: 63px;
  }

  .playing-list-title {
    height: 42px;
    background: #FEECEC;
    text-align: center;
    line-height: 42px;
    font-size: 16px;

    img {
      width: 27px;
      height: 27px;
      position: relative;
      top: 7px;
      margin-right: 5px;
    }
  }

  .unstart-list-title {
    height: 42px;
    background: #EDF3FE;
    text-align: center;
    line-height: 42px;
    font-size: 16px;

    img {
      width: 27px;
      height: 27px;
      position: relative;
      top: 7px;
      margin-right: 5px;
    }
  }

  .end-list-title {
    height: 42px;
    background: #EDFEF9;
    text-align: center;
    line-height: 42px;
    font-size: 16px;

    img {
      width: 27px;
      height: 27px;
      position: relative;
      top: 7px;
      margin-right: 5px;
    }
  }

  .game-list-item {
    height: 86px;
    display: flex;
    background: #fff;
    border-bottom: 1px solid rgba(0, 0, 0, 0.25);
  }
}

.page-loading {
  min-height: 70vh;

  .img-wrap {
    position: fixed;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 150px;
    height: 150px;
    background: rgba(0, 0, 0, .1);
    border-radius: 50%;

    img {
      margin: 55px 0 0 20px;
      animation: jiazai 4s ease-in-out infinite forwards;
    }
  }
}

.empty-page {
  img {
    display: block;
    width: 50%;
    margin: 80px auto;
  }

  p {
    text-align: center;
    font-size: 16px;
    position: relative;
    top: -150px;
  }
}
</style>
